import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppRoutes } from './routes';
import ReactDOM from 'react-dom/client';
import TwoFANoticeBanner from './components/layout/twofa-notice-banner.component';
import { SessionProvider } from './sessionProvider';
import './i18/i18';
import moment from 'moment';

moment.locale('es');

const Layout = () => {
  return (
    <>
      <BrowserRouter>
        <SessionProvider>
          <TwoFANoticeBanner />
          {AppRoutes}
        </SessionProvider>
      </BrowserRouter>

      <ToastContainer
        position="top-center"
        newestOnTop
        draggable
        autoClose={4000}
        closeButton={false}
        style={{ zIndex: 99999 }}
      />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<Layout />);
